/**
 * Mobile Bottom Navigation — 4 equal-sized icons
 * Feed · Post FoodCard · Surprise · Profile
 */
import { User, Sparkles } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FoodCardIcon from './FoodCardIcon';

/* Compact chef hat icon for Feed — matches lucide stroke style */
const FQFeedIcon = ({ className = '', strokeWidth = 1.8 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M6 19h12" />
    <path d="M6 16h12v3H6z" />
    <path d="M6 16c-2 0-3.5-1.5-3.5-3.5S4 9 6 9c0-2.5 2.5-4.5 6-4.5s6 2 6 4.5c2 0 3.5 1.5 3.5 3.5S20 16 18 16" />
  </svg>
);

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const path = location.pathname;

  const isActive = (itemPath) => {
    if (itemPath === '/') return path === '/' || path === '/foodie';
    return path.startsWith(itemPath);
  };

  const postActive = path === '/create-foodcard';

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-100 md:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }} data-testid="mobile-bottom-nav">
      <div className="flex items-center h-14">
        <Link to="/" className="flex flex-col items-center justify-center flex-1 h-full" data-testid="bottom-nav-feed">
          <FQFeedIcon className={`w-6 h-6 ${isActive('/') ? 'text-[#FF6B35]' : 'text-gray-400'}`} strokeWidth={isActive('/') ? 2 : 1.5} />
          <span className={`text-[10px] mt-0.5 ${isActive('/') ? 'text-[#FF6B35] font-semibold' : 'text-gray-400'}`}>Feed</span>
        </Link>

        <button onClick={() => user ? navigate('/create-foodcard') : navigate('/profile')}
          className="flex flex-col items-center justify-center flex-1 h-full" data-testid="bottom-nav-post-foodcard">
          <FoodCardIcon size={24} active={postActive} className={postActive ? 'text-[#FF6B35]' : 'text-gray-400'} />
          <span className={`text-[10px] mt-0.5 ${postActive ? 'text-[#FF6B35] font-semibold' : 'text-gray-400'}`}>FoodCard</span>
        </button>

        <Link to="/surprise-me" className="flex flex-col items-center justify-center flex-1 h-full" data-testid="bottom-nav-ai-search">
          <Sparkles className={`w-6 h-6 ${isActive('/surprise-me') || isActive('/ai-search') ? 'text-[#FF6B35]' : 'text-gray-400'}`} strokeWidth={isActive('/surprise-me') || isActive('/ai-search') ? 2 : 1.5} />
          <span className={`text-[10px] mt-0.5 ${isActive('/surprise-me') || isActive('/ai-search') ? 'text-[#FF6B35] font-semibold' : 'text-gray-400'}`}>Surprise</span>
        </Link>

        <Link to="/profile" className="flex flex-col items-center justify-center flex-1 h-full" data-testid="bottom-nav-profile">
          <User className={`w-6 h-6 ${isActive('/profile') ? 'text-[#FF6B35]' : 'text-gray-400'}`} strokeWidth={isActive('/profile') ? 2 : 1.5} />
          <span className={`text-[10px] mt-0.5 ${isActive('/profile') ? 'text-[#FF6B35] font-semibold' : 'text-gray-400'}`}>Profile</span>
        </Link>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
